import { combineReducers } from 'redux';

const byId = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_LISTS_SUCCESS':
      return {
        ...state,
        ...action.response.entities.lists,
        ...action.response.entities.heroes,
      };
    default:
      return state;
  }
};

const listsByPathname = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_LISTS_SUCCESS':
      return {
        ...state,
        [action.pathname]: action.response.result.lists,
      };
    default:
      return state;
  }
};

const heroByPathname = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_LISTS_SUCCESS':
      return {
        ...state,
        [action.pathname]: action.response.result.heroes,
      };
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_LISTS_REQUEST':
      return true;
    case 'FETCH_LISTS_SUCCESS':
    case 'FETCH_LISTS_FAILURE':
      return false;
    default:
      return state;
  }
};

export const getListMetadata = pageType => {
  switch (pageType) {
    case 'videoPermalink':
      return [
        { displayType: 'module', itemsPerPage: 100, paginated: false },
        { displayType: 'module', itemsPerPage: 100, paginated: false },
      ];
      break;
    case 'gamePermalink':
    case 'bookPermalink':
      return [{ displayType: 'module', itemsPerPage: 6, paginated: false }];
      break;
    case 'gamesLanding':
    case 'videosLanding':
    case 'booksLanding':
    case 'gradeLanding':
    case 'mathZone':
      return [
        { displayType: 'module', itemsPerPage: 5, paginated: false },
        { displayType: 'grid', itemsPerPage: 12, paginated: true },
      ];
      break;
    case 'homepage':
      return [
        { displayType: 'module', itemsPerPage: 5, paginated: false },
        { displayType: 'module', itemsPerPage: 5, paginated: false },
        { displayType: 'module', itemsPerPage: 5, paginated: false },
        { displayType: 'module', itemsPerPage: 5, paginated: false },
        { displayType: 'module', itemsPerPage: 5, paginated: false },
        { displayType: 'module', itemsPerPage: 5, paginated: false },
      ];
      break;
    default:
      return [];
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_LISTS_FAILURE':
      return action.error;
    case 'FETCH_LISTS_SUCCESS':
    case 'FETCH_MEDIA_REQUEST':
    case 'FETCH_LISTS_REQUEST':
      return null;
    default:
      return state;
  }
};

const lists = combineReducers({
  byId,
  listsByPathname,
  heroByPathname,
  isFetching,
  error,
});
export default lists;

export const getIsFetching = state => state.isFetching;
